import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Permission,
  PushNotification,
} from '../interfaces/notifications.interface';

@Injectable()
export class PushNotificationsService {
  public permission!: Permission;
  private _audio!: HTMLAudioElement;

  constructor() {
    /*this.permission = this.isSupported() ? 'default' : 'denied';
    const blob = new Blob([response], { type: 'audio/mpeg' });
    const url = URL.createObjectURL(blob);*/
    // this.audio.src ='../../../assets/sounds/bits.ogg';
  }

  public playSoundNotification() {
    this._audio = new Audio('./assets/sounds/bits.ogg');
    this._audio.play();
  }

  public isSupported(): boolean {
    return 'Notification' in window;
  }

  requestPermission(): void {
    const self = this;
    if ('Notification' in window) {
      Notification.requestPermission(function (status) {
        return (self.permission = status);
      });
    }
  }

  create(title: string, options?: PushNotification) {
    const self = this;

    this.playSoundNotification();

    return new Observable(function (obs) {
      if (!('Notification' in window)) {
        obs.complete();
      }
      if (self.permission !== 'granted') {
        obs.complete();
      }
      const _notify = new Notification(title, options);
      _notify.onshow = function (e) {
        return obs.next({
          notification: _notify,
          event: e,
        });
      };
      _notify.onclick = function (e) {
        return obs.next({
          notification: _notify,
          event: e,
        });
      };
      _notify.onerror = function (e) {
        return obs.error({
          notification: _notify,
          event: e,
        });
      };
      _notify.onclose = function () {
        return obs.complete();
      };
    });
  }
}
